import Icon from '../components/Icon'

Icon.register({
  'assistive-listening-systems': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 260c0 15.5-12.5 28-28 28s-28-12.5-28-28c0-44.1 35.9-80 80-80s80 35.9 80 80c0 15.5-12.5 28-28 28s-28-12.5-28-28c0-13.2-10.8-24-24-24s-24 10.8-24 24zM240 84c97 0 176 79 176 176 0 96-71.4 109.8-72 144.2-0.1 59.4-48.5 107.8-108 107.8-15.5 0-28-12.5-28-28s12.5-28 28-28c28.7 0 52-23.3 52-52l0-0.4c1-73.3 72-68.5 72-143.6 0-66.2-53.8-120-120-120s-120 53.8-120 120c0 15.5-12.5 28-28 28s-28-12.5-28-28c0-97 79-176 176-176zM160 320c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM32 448c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM512 260c0 15.5-12.5 28-28 28s-28-12.5-28-28c0-1.1 0-2.2 0-3.4l0-0.2c-1.5-91.4-60.2-172.6-146.1-202-14.6-5-22.4-20.9-17.4-35.5 5-14.6 20.9-22.4 35.5-17.4 108.2 37 182.1 139 184 254 0 1.5 0 3 0 4.5zM153 439l-33.9 33.9-80-80 33.9-33.9z'
      }
    ]
  }
})
